import { jsx as _jsx } from "react/jsx-runtime";
const Back = () => (_jsx("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "m15.63 22.19 12.47-12.6-4.97-4.98-21.13 21.13 21.13 20.98 4.97-5-12.42-12.42h39.23v29.29h7.09v-36.4z" }) })));
Back.iconName = "back";
Back.iconCategory = "Misc - Deprecated";
Back.deprecated = true;
export default Back;
